let develop = {
  dev: 'release'
}

module.exports = develop



// WEBPACK FOOTER //
// ./src/util/config.js